export default "__VITE_ASSET__290e66bb__"